module.exports = __webpack_public_path__ + "static/media/bt-forecast.46a4b66f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-forecast.png
// module id = 685
// module chunks = 0